"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
/* DropdownMenu auto-generated by npm run generator */
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const useStyles = core_1.makeStyles((theme) => ({
    dropdownMenu: {
        boxShadow: "none",
        padding: 0,
    },
    dropdownMenuLetter: {
        fontSize: theme.spacing(3),
        lineHeight: 0,
        width: theme.spacing(4),
        height: theme.spacing(4),
        minWidth: theme.spacing(4),
        minHeight: theme.spacing(4),
        letterSpacing: 0,
    },
}));
exports.DropdownMenu = (props) => {
    const classes = useStyles();
    const className = clsx_1.default([props.className, classes.dropdownMenu, props.name ? classes.dropdownMenuLetter : ""]);
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);
    const handleOptClick = (option) => {
        return (event) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            event.stopPropagation();
            handleClose();
            yield ((_a = option.callback) === null || _a === void 0 ? void 0 : _a.call(option));
        });
    };
    const handleNoOpt = (event) => {
        event.stopPropagation();
        handleClose();
    };
    const opts = props.options.map((option) => {
        var _a;
        return (react_1.default.createElement(core_1.MenuItem, { key: option.name, onClick: option.callback ? handleOptClick(option) : handleNoOpt }, (_a = option.element) !== null && _a !== void 0 ? _a : option.name));
    });
    return (react_1.default.createElement("div", null,
        props.noBackground ? (react_1.default.createElement(core_1.IconButton, { "aria-haspopup": "true", onClick: handleClick, className: className }, props.children)) : (react_1.default.createElement(core_1.Fab, { "aria-haspopup": "true", onClick: handleClick, className: className, size: "large", color: "primary" }, props.children)),
        react_1.default.createElement(core_1.Menu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, onBackdropClick: (e) => e.stopPropagation() }, opts)));
};
//# sourceMappingURL=DropdownMenu.js.map